import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, startWith } from 'rxjs/operators';
import { WebPaths } from '@partner/shared/SharedConstants';
import { DASHBOARDS_NAV_LABEL, DashboardPageDefinition } from '../../dashboard.data';
import { DashboardNavFacade } from '../../domain/+state/dashboard-nav.facade';
import { findDashboardPage, findSidenavItems } from '../dashboard-nav.helper';

export interface DashboardBreadcrumbVm {
  /** The current dashboard sub-page; `null` on the Dashboards parent. */
  page: DashboardPageDefinition | null;
}

/**
 * App-bar `title` outlet for the dashboard shell. Lives across in-shell navigation, so it also re-marks the sidenav
 * selection on every `NavigationEnd` (the resolver only marks the initial paint).
 */
@UntilDestroy()
@Component({
  selector: 'ifbp-dashboard-breadcrumb',
  templateUrl: './dashboard-breadcrumb.component.html',
  styleUrls: ['./dashboard-breadcrumb.component.scss'],
  standalone: false,
})
export class DashboardBreadcrumbComponent implements OnInit {
  vm: DashboardBreadcrumbVm = { page: null };
  readonly dashboardsLabel = DASHBOARDS_NAV_LABEL;
  readonly dashboardPath = WebPaths.Dashboard;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly navFacade: DashboardNavFacade,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        untilDestroyed(this),
      )
      .subscribe(() => this.refresh());
  }

  private refresh(): void {
    this.vm = { page: findDashboardPage(this.router.routerState.snapshot) };
    this.navFacade.select(findSidenavItems(this.route.snapshot), this.router.url);
  }
}
